export enum GroupedBy {
    Drug,
    Location,
    GPI
}